import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "social-media-twitter",
  "use": "social-media-twitter-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 200 200\" id=\"social-media-twitter\"><path d=\"M170 0H30A30.09 30.09 0 000 30v140a30.09 30.09 0 0030 30h140a30.09 30.09 0 0030-30V30a30.09 30.09 0 00-30-30zm-53.84 87.27h-10.79v44.33q-.15 5.79 5.25 5.64h5.53v14.35h-7.72a17.22 17.22 0 01-12.75-5q-5.1-4.75-5.1-13.75V87.27h-7.41V75.56h7.42V52.42h14.78v23.14h10.79z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol